// extracted by mini-css-extract-plugin
export default {"new-measure":"_new-measure_liwc2J"};